export default [
  {
    path: 'trademanage',
    name: 'trademanage',
    component: resolve => {
      require(['@/modules/UserCenter/Order'], resolve);
    },
    beforeEnter: (to, from, next) => {
      if (to.params.roleName === 'factory') {
        next();
      } else {
        next({ path: '/' });
      }
    },
    children: [
      {
        path: 'mngmodelorder',
        name: 'mngmodelorder',
        component: resolve => {
          require(['@/modules/UserCenter/Order/ManageOrder'], resolve);
        }
      },
      {
        path: 'mngmodelorder/detail/:id',
        name: 'mngmodelorderdetail',
        component: resolve => {
          require(['@/modules/UserCenter/Order/Detail'], resolve);
        }
      },
      {
        path: 'mngmodelorder/quote/:id',
        name: 'mngmodelorderquote',
        component: resolve => {
          require(['@/modules/UserCenter/Order/Quote'], resolve);
        }
      },
      {
        path: 'mngmarketorder',
        name: 'mngmarketorder',
        component: resolve => {
          require(['@/modules/UserCenter/Order/MarketsOrders'], resolve);
        }
      },
      {
        path: 'mngrefundorder',
        name: 'mngrefundorder',
        component: resolve => {
          require(['@/modules/UserCenter/Order/ManageRefund'], resolve);
        }
      },
      {
        path: 'mngrefundorder/detail/:id',
        name: 'mngrefundorderdetail',
        component: resolve => {
          require(['@/modules/UserCenter/Order/Detail'], resolve);
        }
      }
    ],
    redirect: 'trademanage/mngmodelorder'
  }
];



// WEBPACK FOOTER //
// ./src/router/factory.js